var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoodIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 72,
    viewBox: "0 0 48 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13185_1816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3848 14.4956L35.7128 8.01562L42.0968 18.9116L30.9128 25.1516L24.3848 14.4956Z",
    fill: "#C924A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8801 21.0724C22.6562 21.0724 24.0961 19.7185 24.0961 18.0484C24.0961 16.3783 22.6562 15.0244 20.8801 15.0244C19.1039 15.0244 17.6641 16.3783 17.6641 18.0484C17.6641 19.7185 19.1039 21.0724 20.8801 21.0724Z",
    fill: "#2F6761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3768 43.4402C30.5697 43.4402 31.5368 42.5376 31.5368 41.4242C31.5368 40.3108 30.5697 39.4082 29.3768 39.4082C28.1839 39.4082 27.2168 40.3108 27.2168 41.4242C27.2168 42.5376 28.1839 43.4402 29.3768 43.4402Z",
    fill: "#2F6761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.664 23.3281L25.392 24.3841L24.384 31.9681L16.752 30.6721L17.664 23.3281Z",
    fill: "#FF4A37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5918 44.3996L37.8238 42.4316L40.4638 48.2396L34.3198 50.3516L32.5918 44.3996Z",
    fill: "#FF4A37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2637 34.6563L36.0957 25.1523C36.0957 25.1523 40.3197 30.2403 36.5277 34.6563C35.4237 35.6643 31.2477 38.3523 27.2637 34.6563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7207 39.4081L21.0727 35.6641L24.7207 37.9681L22.3207 41.4241L18.7207 39.4081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0645 45.7921C14.0645 45.7921 17.3765 51.2161 21.5045 45.1201",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7128 72.0001C17.7128 72.0001 18.8168 68.8321 18.3368 65.1361C17.5208 64.8001 14.8328 64.9921 12.4808 63.5041C12.3368 62.1121 12.4808 56.5921 12.4808 56.5921C12.4808 56.5921 12.8168 55.1041 11.4248 54.9601C10.0328 54.8161 7.63281 54.2401 7.63281 54.2401C7.63281 54.2401 9.98481 52.0321 12.1448 43.7281C13.1048 40.1281 15.3128 27.6961 29.6648 28.0321C30.5288 28.2241 40.8488 28.4641 39.5048 42.7201C39.3608 44.5921 37.2008 50.8321 34.4168 54.4321C32.5448 57.2161 27.2168 64.9441 33.0248 72.0001",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13185_1816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodIcon);
export default __webpack_public_path__ + "static/media/mood-icon.ef0f7e0795797f3c266e52a714c61904.svg";
export { ForwardRef as ReactComponent };